import { AxiosHeaders } from 'axios';

export const API_CUBE_CORE = process.env.API;

export const HEADERS: AxiosHeaders['Content-Type'] = {
  'Content-Type': 'application/json',
};
